import { X } from 'lucide-react'
import { forwardRef } from 'react'
import { useSpEditorProvider } from './SpEditorProvider'
import { SuggestionListItem } from '../type'

interface SuggestionDropdownProps<SuggestionListItem> {
    className?: string
    onSelect?: (option: SuggestionListItem) => void
}

export const SuggestionDropdown = forwardRef(
    (props: SuggestionDropdownProps<SuggestionListItem>, ref: React.Ref<HTMLDivElement>) => {
        const { onSelect } = props
        const { suggestionProps } = useSpEditorProvider()
        const shouldShowSuggestion =
            suggestionProps.options?.length > 0 && suggestionProps.coords !== undefined

        return (
            <div
                ref={ref}
                className=" bg-white border rounded shadow px-2 py-1"
                aria-hidden={!shouldShowSuggestion}
                style={{
                    position: 'absolute',
                    top: suggestionProps.coords?.top,
                    left: suggestionProps.coords?.left,
                    visibility: shouldShowSuggestion ? 'visible' : 'hidden',
                    opacity: shouldShowSuggestion ? 1 : 0,
                }}
            >
                <div className="flex items-center justify-between text-sm text-gray-700 px-3 py-2 font-medium border-b">
                    <div className="mr-5">Suggestions</div>
                    <div className="flex items-center gap-2 px-2 py-1  rounded text-xs text-red-800">
                        <X size={14} className="cursor-pointer0" />
                        <span className="font-mono">[esc]</span>
                    </div>
                </div>
                <ul>
                    {suggestionProps.options.map((option, index) => (
                        <div
                            key={index}
                            tabIndex={0}
                            role="button"
                            className="flex justify-between items-center px-3 py-1.5 rounded text-sm text-gray-700 cursor-pointer hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
                            onClick={() => onSelect?.(option)}
                        >
                            <div className="flex-1">{option.title}</div>
                            <span className="text-xs text-gray-400 font-mono ml-4">
                                {index + 1}
                            </span>
                        </div>
                    ))}
                </ul>
            </div>
        )
    }
)
